
export const useLoopPlugin = (onLoopClick: () => void) => {
  if (typeof window === "undefined") return;

  const tryRegister = () => {
    if ((window as any).tinymce?.PluginManager?.lookup?.loopPlugin) return;
    if (!(window as any).tinymce) {
      setTimeout(tryRegister, 50); // Retry until tinymce is available
      return;
    }
    (window as any).tinymce.PluginManager.add("loopPlugin", function (editor: any) {
      editor.ui.registry.addButton("loopButton", {
        text: "Loop",
        tooltip: "Insert Loop",
        onAction: function () {
          onLoopClick();
        },
      });
    });
  };

  tryRegister();
};